import { getBaseUrl } from "./apiUtils";

const baseUrl = getBaseUrl();

export async function CheckIn(clienteData, idRichiesta) {
  let url = `${baseUrl}booking/checkin`;
  if (idRichiesta !== null && idRichiesta !== undefined) {
    url += `?idRichiesta=${idRichiesta}`;
  }

  const res = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(clienteData),
  });

  return res;
  // return res.json();
}

export async function GetCheckInData(idRichiesta, idScuola) {
  const res = await fetch(`${baseUrl}booking/checkindata?codcheckin=${idRichiesta}&idscuola=${idScuola}`, {
    method: "GET",
  });

  return res;
}
